import { NodeDefinition } from 'Automations/nodeDefinitions/types'

export const getNodeDescription = <Config extends Record<string, unknown>>(
  definition: Pick<NodeDefinition<Config>, 'description'>,
  config: Config
): string | undefined =>
  typeof definition.description === 'function'
    ? definition.description({ config })
    : definition.description
